module.exports = __webpack_public_path__ + "img/check-to-slot.58f252a2.svg";